import { VoxoraLockup } from './Brand'
import { CAPABILITY, SITE, SITE_SECTIONS } from '../lib/site'
import { ESTIMATE_PATH, goToSection, navigate, sectionHref } from '../lib/router'
import { LEGAL_LINKS } from '../lib/legal'
import { panelUjranyitasa } from '../lib/consent'
import { pixelBeallitva } from '../lib/metaPixel'

export default function Footer(): JSX.Element {
  const onSection = (event: React.MouseEvent<HTMLAnchorElement>, hash: string): void => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
    event.preventDefault()
    goToSection(hash)
  }

  const onRoute = (event: React.MouseEvent<HTMLAnchorElement>, path: string): void => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
    event.preventDefault()
    navigate(path)
  }

  return (
    <footer className="footer">
      <div className="shell footer__shell">
        <section className="footer__cta" aria-labelledby="footer-cta-title">
          <div className="footer__cta-copy">
            <span className="footer__kicker">
              <span className="footer__signal" aria-hidden="true" />
              Kész 3D fájlból kézzelfogható darab
            </span>
            <h2 className="footer__title" id="footer-cta-title">
              Kész a 3D fájlod?
              <em>Nézd meg az árát.</em>
            </h2>
            <p className="footer__about">
              Töltsd fel az STL, OBJ vagy 3MF fájlt, válaszd ki az anyagot és a
              rétegprofilt, majd azonnal látod a gyártási díjat. A fájlt automatikusan
              ellenőrizzük; gyártani csak a jóváhagyásod után kezdünk.
            </p>
          </div>

          <div className="footer__action">
            <span className="footer__action-label">Online árkalkuláció</span>
            <a
              className="footer__primary"
              href={ESTIMATE_PATH}
              onClick={(event) => onRoute(event, ESTIMATE_PATH)}
            >
              <span>Árkalkuláció indítása</span>
              <span className="footer__primary-arrow" aria-hidden="true">↗</span>
            </a>
            <div className="footer__response">
              <span>Ár megjelenése</span>
              <strong>azonnal</strong>
              <i aria-hidden="true" />
              <span>Műszaki válasz</span>
              <strong>4 órán belül</strong>
            </div>
          </div>
        </section>

        <div className="footer__directory">
          <div className="footer__identity">
            <a
              className="footer__home"
              href="/"
              aria-label="VOXORA főoldal"
              onClick={(event) => onRoute(event, '/')}
            >
              {/* Ejszakai lablec: a `dark` tonus a sotet alapra valo, vilagos tinta. */}
              <VoxoraLockup size={24} tone="dark" />
              <span className="footer__home-label">VOXORA főoldal</span>
            </a>
            <p>Kész STL, OBJ és 3MF fájlok gyártása, ellenőrzött beállításokkal és átlátható áron.</p>
            {(SITE.email || SITE.phone || SITE.city) && (
              <div className="footer__contact" aria-label="Kapcsolat">
                {SITE.email && <a href={`mailto:${SITE.email}`}>{SITE.email}</a>}
                {SITE.phone && (
                  <a href={`tel:${SITE.phone.replace(/\s/g, '')}`}>{SITE.phone}</a>
                )}
                {SITE.city && <span>{SITE.city}</span>}
              </div>
            )}
          </div>

          <nav className="footer__nav" aria-label="Az oldalon">
            <span className="footer__head">Az oldalon</span>
            <div className="footer__nav-links">
              {SITE_SECTIONS.map((section) => (
                <a
                  key={section.hash}
                  className="link"
                  href={sectionHref(section.hash)}
                  onClick={(event) => onSection(event, section.hash)}
                >
                  {section.label}
                </a>
              ))}
            </div>
          </nav>
        </div>

        <dl className="footer__facts" aria-label="Gyártási keretek">
          <div className="footer__fact">
            <dt>Maximális méret</dt>
            <dd>
              {CAPABILITY.maxSize.x} × {CAPABILITY.maxSize.y} × {CAPABILITY.maxSize.z}
              <small> mm</small>
            </dd>
          </div>
          <div className="footer__fact">
            <dt>Anyagok</dt>
            <dd>PLA + PETG</dd>
          </div>
          <div className="footer__fact">
            <dt>Rétegmagasság</dt>
            <dd>
              {String(CAPABILITY.layerRange.min).replace('.', ',')}–
              {String(CAPABILITY.layerRange.max).replace('.', ',')}
              <small> mm</small>
            </dd>
          </div>
          <div className="footer__fact">
            <dt>Átvétel</dt>
            <dd>3 lehetőség</dd>
          </div>
        </dl>

        <div className="footer__utility">
          <nav className="footer__legal" aria-label="Jogi információk">
            {LEGAL_LINKS.map((item) => (
              <a
                key={item.path}
                className="link"
                href={item.path}
                onClick={(event) => onRoute(event, item.path)}
              >
                {item.label}
              </a>
            ))}
            {/*
              A HOZZAJARULAS VISSZAVONASA MINDEN OLDALROL ELERHETO.

              A GDPR 7. cikk (3) szerint a visszavonasnak ugyanolyan
              egyszerunek kell lennie, mint a megadasnak. A megadas egy
              kattintas volt egy savon; ez is egy kattintas, a lablecben,
              az oldal minden lapjan.

              `<button>`, nem `<a>`: nem navigal sehova, hanem visszahozza
              a panelt. A `link` osztaly a kinezetet adja, a
              `footer__consent` pedig visszaveszi a gomb sajat
              alapertelmezeseit.

              Ha nincs beallitva pixel, nincs mit visszavonni - ilyenkor a
              hivatkozas meg sem jelenik.
            */}
            {pixelBeallitva && (
              <button
                type="button"
                className="link footer__consent"
                onClick={panelUjranyitasa}
              >
                Süti-beállítások
              </button>
            )}
          </nav>

          <div className="footer__bottom">
            <span className="tele">© {new Date().getFullYear()} VOXORA</span>
            <span className="tele">
              Alanyi adómentes vállalkozás; a végleges ajánlatban ÁFÁ-t nem számítunk
              fel.{SITE.taxNumber ? ` Adószám: ${SITE.taxNumber}` : ''}
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}
